import $ from "jquery";

const ajax = {
    post(url, reqData) {
        return $.ajax({
            type: "POST",
            url,
            data: (reqData != null) ? JSON.stringify(reqData) : "",
            dataType: "json",
            contentType: "application/json"
        });
    },
    get(url, reqData) {
        return $.get(url, reqData);
    }
};

export default ajax;